import React, { createContext, useContext, forwardRef } from 'react';

const ModalContext = createContext();

export const useModal = () => useContext(ModalContext);

const Modal = forwardRef(({ children, className, id }, ref) => {
  const closeModal = () => {
    console.log('closeModal')
    ref.current.close();
  }

  // Generate a random id if not provided
  if (!id) {
    id = `modal-${Math.random().toString(36).slice(2, 9)}`;
  }

  return (
    <ModalContext.Provider value={closeModal}>
      <dialog ref={ref} className="modal" id={id}>
        <div className={`modal-box relative ${className ? className : ''}`}>
          <button onClick={closeModal} className='btn btn-sm btn-circle btn-ghost absolute right-2 top-2'>X</button>
          {children}
        </div>
        <form method="dialog" className="modal-backdrop ">
          <button className='bg-transparent'>close</button>
        </form>
      </dialog>
    </ModalContext.Provider>
  )
});

export default Modal;
